import(/* webpackMode: "eager" */ "/vercel/path0/apps/tools/src/app/global-error.tsx");
